import Vue from 'vue'
import account from './modules/account' // 账户/权限/日志

const apis = {
  common: {
    commonBaseGetArea: `/platform-api-v3/common/base/getAreaList`, // 查询区域
    mallCategory: `/platform-api-v3/mall/category/page` // 商品类别
  },
  ...account
}
export default apis

Vue.prototype.$apis = apis
